import React from "react";
import { Box } from "@primer/react";
import {
  CheckCircleIcon,
  AlertIcon,
  SyncIcon,
  BlockedIcon,
} from "@primer/octicons-react";

interface StatusIconProps {
  status: string;
  isNew?: boolean;
  // Finished, but not everything came across. A green tick over a line saying
  // things could not be copied reads as a contradiction, so this gets its own
  // amber state between success and failure.
  hasIssues?: boolean;
}

export const StatusIcon: React.FC<StatusIconProps> = ({ status, isNew, hasIssues }) => {
  if (status === "complete" && hasIssues) {
    return (
      <Box sx={{ color: "attention.fg", display: "flex" }}>
        <AlertIcon size={16} />
      </Box>
    );
  }

  switch (status) {
    case "pending":
      return (
        <Box sx={{ color: "fg.muted", display: "flex" }}>
          <BlockedIcon size={16} />
        </Box>
      );
    case "processing":
      return (
        <Box sx={{ color: "accent.fg", display: "flex" }}>
          <SyncIcon size={16} className="anim-rotate" />
        </Box>
      );
    case "complete":
      return (
        <Box
          sx={{
            color: isNew ? "var(--fgColor-success, #1a7f37)" : "fg.muted",
            display: "flex",
          }}
        >
          <CheckCircleIcon size={16} />
        </Box>
      );
    case "failed":
      return (
        <Box sx={{ color: "danger.fg", display: "flex" }}>
          <AlertIcon size={16} />
        </Box>
      );
    default:
      return null;
  }
};
